module.exports = __webpack_public_path__ + "static/media/digital-banking.88620faa.png";